import { call, put, select, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';

import API from '@sm/api';
import { setNotificationMsgAction, setSuccessMsgAction } from 'seller/store/actions';
import {
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_FAILURE,
  CANCEL_SUBSCRIPTION_SUCCESS
} from 'seller/store/actions/billing.actions';
import { SET_NETWORK_ACTIVITY } from 'seller/store/actions/network.actions';
import { SET_USER_PROFILE } from 'seller/store/actions/user.actions';
import { userSelector } from 'seller/store/reducers';

function* cancelSubscriptionSaga() {
  const { userId, profile } = yield select(userSelector);

  try {
    yield put({ type: SET_NETWORK_ACTIVITY, isFetching: true });

    const response = yield call(axios.post, API.billing.cancelSubscription, { userId });

    yield put({ type: CANCEL_SUBSCRIPTION_SUCCESS, payload: response.data });

    const updatedProfile = {
      ...profile,
      status: 'Canceled'
    };
    yield put({ type: SET_USER_PROFILE, profile: updatedProfile });

    yield put(setSuccessMsgAction('Your subscription has been successfully canceled.'));
  } catch (error) {
    yield put({ type: CANCEL_SUBSCRIPTION_FAILURE, error });
    yield put(
      setNotificationMsgAction(
        error.response ? error.response.data : 'Failed to cancel subscription'
      )
    );
  } finally {
    yield put({ type: SET_NETWORK_ACTIVITY, isFetching: false });
  }
}

export function* billingSagaWatcher() {
  yield takeLatest(CANCEL_SUBSCRIPTION, cancelSubscriptionSaga);
}
